import React, { ChangeEvent, memo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, SelectChangeEvent } from '@mui/material';
import { SelectField } from '@qrios/frontend-library';

interface Props {
  possibleRoles: string[];
  selectedRole: string;
  handleSelectRole: (value: unknown) => void;
  handleBlur: (
    e: ChangeEvent<{
      name: string;
      value: string;
    }>
  ) => void;
}

const RoleSelector = ({ selectedRole, possibleRoles, handleSelectRole, handleBlur }: Props) => {
  const theme = useTheme();

  return (
    <Box height={theme.customComponents.usageSummaryMonthSelector.height}>
      <SelectField
        name="role"
        label="User role"
        value={selectedRole}
        handleChange={(e: SelectChangeEvent) => handleSelectRole(e.target.value)}
        items={possibleRoles.map(item => ({ label: item, value: item }))}
        handleBlur={handleBlur}
      />
    </Box>
  );
};

export default memo(RoleSelector);
